import {
    Container,
    ContainerGutter,
    ContainerPadding,
    CTA,
    Text,
} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {Close} from '@volkswagen-onehub/icons-core'

import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {closeDisclaimerLayer} from './launchers/DisclaimerLayerHandle'
import {RootState} from '../rootReducer'

const ContainerDisclaimer = styled.div`
    padding-right: ${(props) => props.theme.size.static530};
`

const CTAClose = styled(CTA)`
    position: absolute;
    right: ${(props) => props.theme.size.static250};
    top: ${(props) => props.theme.size.static250};
`

export function DisclaimerVum(): React.JSX.Element {
    const {t} = useTranslation('fa-coupon')

    const configuration = useSelector(
        (state: RootState) => state.configurationPromo.configuration
    )

    return (
        <>
            <Container
                gutter={ContainerGutter.static300}
                padding={ContainerPadding.static350}
                wrap="always"
            >
                <ContainerDisclaimer>
                    <Text>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('layers.disclaimer.dataDisclaimer', {
                                    promo: configuration.name,
                                }),
                            }}
                        />
                    </Text>
                    <CTAClose
                        tag="button"
                        emphasis="tertiary"
                        aria-label="Close iteraction layer"
                        iconPosition="top"
                        onClick={closeDisclaimerLayer}
                        icon={<Close aria-hidden />}
                    />
                </ContainerDisclaimer>
            </Container>
        </>
    )
}
